import React, { FC, useContext } from 'react';
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import { LinkButton, RichMarkdownIt, SearchComponent, UserStateComponent } from '../../components';
import { useTranslation } from '../../translations';
import { CashierContext } from './cashiercontext';

export const CashierHome: FC = () => {
  const { ts } = useTranslation();
  const {
    config: { primaryPrinter, secondaryPrinter },
  } = useContext(CashierContext);

  return (
    <UserStateComponent>
      <Row>
        {!primaryPrinter && !secondaryPrinter && (
          <Col xs={12}>
            <Alert color="warning">
              <strong>{ts('warning')}:</strong>{' '}
              {ts('no_printers_are_configured_for_this_registration_station')}
            </Alert>
          </Col>
        )}
        <Col xs={8}>
          <SearchComponent
            hideHelp
            redirectOnSingle
            redirectUrl="/housekeeping/cashier"
            showBornAt
          />
        </Col>
        <Col xs={4}>
          <Card>
            <CardBody>
              <LinkButton block outline to="/housekeeping">
                {ts('exit_registration_station')}
              </LinkButton>
              <hr />
              <h4>{ts('search_help')}</h4>

              <RichMarkdownIt source={ts('home.to_search_for')} />
              <ul>
                <li>{ts('common.badge_id')}</li>
                <li>{ts('common.username')}</li>
                <li>{ts('common.to_search_for__item__name')}</li>
                <li>{ts('common.phone_number')}</li>
                <li>{ts('common.email_address')}</li>
              </ul>

              <p>{ts('when_enable_auto_navigate_is')}</p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </UserStateComponent>
  );
};
